import { render, staticRenderFns } from "./Assistants.vue?vue&type=template&id=3eeaf4bc&scoped=true"
import script from "./Assistants.vue?vue&type=script&lang=js"
export * from "./Assistants.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eeaf4bc",
  null
  
)

export default component.exports